import { handleHasXTokenParamOrSendXToken, responseValidator } from "../../helpers/helpers";
import { IChatMessage } from "../../interfaces/interfaces";
import { apiCaller } from "../../services/apiCaller";
import { API } from "../../services/services";
import {
    setChatEnabled,
    setChatType,
    setDefaultMessages,
    setMessageCount,
    setMessages,
    setPinMessage,
    setRoomId,
    setSocket,
    setUsersInfoInChat
} from "../slices/chatSlice";
import store from "../store";
import { ChatType, ConditionName } from "interfaces";
import { toast } from "mobin-toast";
import io from "socket.io-client";
import { conditions } from "helpers";
import { setChatPopover } from "../slices/popoversSlice";
import axios from "axios";

export const handleGetUsersInChat = async (user_ids: string[]) => {
    const response = await axios({
        url: API().user.profile,
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: user_ids
    });
    if (responseValidator(response.status)) return response.data;
    else return [];
};

export const submitCommentInChat = async (setInputValue?: (value: string) => void, message?: string | undefined, messageId?: number | undefined) => {
    const dispatch = store.dispatch;
    const { roomId, messages, messageCount, chatType } = store.getState().chats;
    const { name, avatar_url } = store.getState().user;
    const _data = {
        room: roomId,
        text: messageId ? undefined : message,
        default_message_id: messageId ?? undefined
    };
    const { data, status } = await submitChatComment(_data);
    if (responseValidator(status)) {
        if (!messageId && chatType === ChatType.private) {
            const ownMessage: IChatMessage = {
                name,
                avatar_url,
                created_at: data.created_at,
                text: message!,
                author: data.author,
                room_id: roomId,
                id: data.id,
                isConfirmed: false
            };
            if (messages) dispatch(setMessages([ownMessage, ...messages]));
            else dispatch(setMessages([ownMessage]));
            dispatch(setMessageCount(messageCount + 1));
        }
    } else toast({ title: "ارتباط با سرور دچار مشکل شده است.", type: "error" });
    if (setInputValue) setInputValue("");
};

export const fetchChatMessage = async (offset: number, setScrollEnd: any) => {
    const { roomId, messages, messageCount } = store.getState().chats;
    const dispatch = store.dispatch;
    const { data, status } = await getAllChatMessages(roomId, offset);
    if (responseValidator(status)) {
        setScrollEnd(false);
        let messChat: any[] = [];
        if (messageCount !== 0) {
            if (messages) {
                messChat = [...messages, ...data.results];
            } else {
                messChat = [...data.results];
            }
        } else messChat = [...data.results];
        dispatch(setMessageCount(data.count));
        handleFirstTimeChatRoomMessage(messChat);
    }
};

export const handleConnectSocket = (setScrollEnd: any) => {
    const dispatch = store.dispatch;
    const { roomId } = store.getState().chats;
    let socket: any;
    socket = io(API().live.liveChat.chat(roomId));
    socket.on("connect", async () => {
        dispatch(setSocket(socket));
        fetchChatMessage(0, setScrollEnd);
        socket.on("message", async (data: IChatMessage[] | IChatMessage) => handleChatRoomMessage(data));
    });
};

export const handleChatRoomMessage = async (data: IChatMessage[] | IChatMessage) => {
    const dispatch = store.dispatch;
    const { messages, chatType } = store.getState().chats;
    const { userId } = store.getState().user;

    if (!Array.isArray(data)) {
        let notConfirmedMessageIndex: any = undefined;
        if (chatType !== ChatType.public && messages)
            notConfirmedMessageIndex = messages.findIndex((message: IChatMessage) => message.id === data.id);
        if (notConfirmedMessageIndex > -1 && messages && messages.length) {
            const cloneMessages = JSON.parse(JSON.stringify(messages));
            cloneMessages[notConfirmedMessageIndex].isConfirmed = true;
            dispatch(setMessages(cloneMessages));
        } else {
            if (chatType === ChatType.auto && userId === data.author) data.isConfirmed = true;
            if (messages && messages.length) dispatch(setMessages([data, ...messages]));
            else dispatch(setMessages([data]));
        }
        const { usersInfoInChat } = store.getState().chats;
        if (!usersInfoInChat.find((user: any) => user.id === data.author)) {
            const userInfoData = await handleGetUsersInChat([data.author]);
            if (userInfoData.length) dispatch(setUsersInfoInChat([...usersInfoInChat, ...userInfoData]));
        }
    }
};

export const handleFirstTimeChatRoomMessage = async (data: IChatMessage[]) => {
    const dispatch = store.dispatch;
    if (data.length) {
        dispatch(setMessages(data));
        let user_ids: string[] = [];
        data.map((item: IChatMessage) => user_ids.push(item.author));
        user_ids = [...new Set(user_ids)];
        const userInfoData = await handleGetUsersInChat(user_ids);
        if (userInfoData.length) dispatch(setUsersInfoInChat(userInfoData));
    } else dispatch(setMessages([]));
};

export const handleChatActiveRoom = async (isChatEnabled: boolean) => {
    const dispatch = store.dispatch;
    const { params } = store.getState().videoData;
    const { roomId, chatEnabled, socket, showChat } = store.getState().chats;
    let roomIdTemp: number | undefined = undefined;
    if (!conditions(ConditionName.hasQuizParams) && conditions(ConditionName.isParamsPortrait) && isChatEnabled) {
        let { data, status } = await apiCaller({ url: API().live.liveChat.getRoomId(+String(params.id)) });
        if (responseValidator(status)) {
            if (roomId !== data.id && socket) {
                dispatch(setMessages([]));
                dispatch(setChatEnabled(false));
            }
            dispatch(setDefaultMessages(data.default_messages));
            dispatch(setPinMessage(data.pin));
            dispatch(setRoomId(data.id));
            dispatch(setChatType(data.type));
            roomIdTemp = data.id;
        }
    } else if (chatEnabled && socket) {
        dispatch(setMessages([]));
        dispatch(setChatEnabled(false));
    }

    if (chatEnabled !== !!roomIdTemp) {
        setTimeout(() => {
            if (showChat) dispatch(setChatPopover(true));
            dispatch(setChatEnabled(!!roomIdTemp));
        }, 0);
    }
};

export const submitChatComment = async (_data: any) => {
    const { data, status } = await apiCaller({
        url: API().live.liveChat.sendChatMessage,
        method: "post",
        data: _data,
        headers: handleHasXTokenParamOrSendXToken(),
        retryPolicy: [
            {
                codeAbove: 400,
                codeBelow: null,
                excludeCodes: [],
                includeCodes: [],
                delay: 2,
                count: 3
            }
        ]
    });
    return { data, status };
};

export const getAllChatMessages = async (roomId: number, offset: number) => {
    const { data, status } = await apiCaller({
        url: API().live.liveChat.getMessageList(roomId),
        method: "GET",
        data: {
            offset: offset,
            limit: 10,
            ordering: "-created_at"
        },
        retryPolicy: [
            {
                codeAbove: 400,
                codeBelow: null,
                excludeCodes: [],
                includeCodes: [],
                delay: 2,
                count: 3
            }
        ]
    });
    return { data, status };
};
